import type { Observable, UnaryFunction } from 'rxjs';
import { filter, map, pipe } from 'rxjs';

export const filterIsTruthy = <T>(): UnaryFunction<Observable<T>, Observable<NonNullable<T>>> =>
  pipe(
    filter<T>((value: T) => Boolean<T>(value) || (value as any) === 0),
    map((value: T) => value as NonNullable<T>)
  );
